module.exports = __webpack_public_path__ + "img/skyline2.10386392.jpg";